import styled from 'styled-components';

export const SSLVerificationContainer = styled.div`
  align-items: center;
  display: flex;
  gap: 8px;
`;
